import React from 'react';

import isEmpty from 'lodash/isEmpty';

import { useParams } from '@gogame/screens';

import { ViewStateContext } from '../ViewStateContext';

const entityNames = [
  'networkId',
  'applicationId',
  'channelId',
  'platformId',
  'affiliateId',
  'countryId',
  'managerId',
];

const getEntityIdsPathByIds = (pathIds, { nodes }) => {
  if (isEmpty(pathIds) || isEmpty(nodes)) {
    return [];
  }

  const [id, ...ids] = pathIds;
  const index = nodes.findIndex((node) => node.entityId === Number(id));

  if (index === -1) {
    return [];
  }

  const { entityId } = nodes[index];

  const entityIds = getEntityIdsPathByIds(ids, nodes[index]);

  if (isEmpty(entityIds)) {
    return [entityId];
  }

  return [entityId, ...entityIds];
};

export const useParamsEntityIds = () => {
  const values = React.useContext(ViewStateContext);
  const {
    network,
    application,
    channel,
    platform,
    affiliate,
    country,
    manager,
  } = useParams();
  const path = [
    network,
    application,
    channel,
    platform,
    affiliate,
    country,
    manager,
  ].filter((i) => i);
  const entityIds = getEntityIdsPathByIds(path, values);
  return entityIds.reduce((acc, id, i) => {
    if (id === -1) {
      return acc;
    }
    return {
      ...acc,
      [entityNames[i]]: id,
    };
  }, {});
};
